const EventBus = window.EventBus;
export const ToggleListSort = {
  props: [
    'component',
    'prop-title',
    'items',
    'selected',
    'collapse',
    'pivot',
    'disable-responsive',
    'sort-condition',
    'prop-sort',
    'gutembergOpts',
    'lang',
  ],
  data: function () {
    return {
      show: false,
      checked: [],
      uniqueInList: null,
      theme_directory: window.theme_directory,
      title: this.propTitle,
      sort: this.propSort,
      displaySort: this.lang == 'fr_CA' ? 'Sélectionner' : 'Select',
      order: {
        'price':'desc',
        'year':'desc',
        'numberofpics': 'desc'
      }
    }
  },
  mounted() {
    EventBus.$on('CLOSE_ALL_OPEN_COMPONENTS', () => {
      if (this.show)
        this.show = false
    });

    this.changeSortDisplay(this.sort.toLowerCase(), this.sortCondition.toLowerCase());

    if (this.gutembergOpts) {
      const sortBy = this.gutembergOpts.sort_by.toLowerCase();
      const sortByCondition = this.gutembergOpts.sort_by_condition.toLowerCase();
  
      if (sortBy && sortByCondition) {
        this.order[sortBy] = sortByCondition;
      }
    }
  },
  methods: {
    /**
     * LBT-1602 (M1): changing Sort By rewrote the URL and re-rendered the
     * results without emitting anything, so sorting was invisible in reporting.
     * The spec files sort under element_type 'filter' ("price sort").
     *
     * element_text carries field and direction together because they are only
     * meaningful as a pair -- 'price asc' and 'price desc' are different user
     * intents, and the field alone cannot tell them apart.
     *
     * Goes through srpSortChange rather than uiInteraction so the event carries
     * the 13-field filter snapshot and srp_total_results the spec attaches to
     * element_type 'filter' (v2.3 §11). This component does not hold that
     * state; the dataLayer module remembers the last one the inventory
     * component reported, which is the listing being sorted (conformance test
     * 2026-10-28, F-2).
     */
    trackLbxSort(field, order) {
      if (!window.LBX || !window.LBX.track || typeof window.LBX.track.srpSortChange !== 'function') {
        return;
      }
      window.LBX.track.srpSortChange([field, order].filter(Boolean).join(' '));
    },
    clear() {
      this.title = this.propTitle;
      this.sort = "";
    },
    sortByDynamic(field, title) {

      this.order[field] === 'asc' ? this.order[field] = 'desc' : this.order[field] = 'asc';

      let query = window.location.search || '';
      let pathnameClear = (window.location.pathname.replace(/\/?sort_order\/[a-zA-Z]+\//gi, '/')).replace(/\/?sort_by\/[a-zA-Z]+\//gi, '/');
      let finalUrl = `${pathnameClear}/sort_by/${field}/sort_order/${this.order[field]}/${query}`

      history.replaceState({}, null, finalUrl.replace('//', '/'));
      this.sort = "";
      this.title = title;
      
      // Get urlParams to include secondary sort parameters
      const urlParams = new URLSearchParams(window.location.search);
      let fieldSecondary = urlParams.get('sort_by_secondary') || (this.gutembergOpts?.sort_by_secondary || 'none');
      let orderSecondary = urlParams.get('sort_order_secondary') || (this.gutembergOpts?.sort_order_secondary || 'none');

      if (field === 'year' && fieldSecondary === 'none') {
        fieldSecondary = 'ininventory';
        orderSecondary = this.order[field];
      }

      EventBus.$emit('sortInventory', {
        field,
        order: this.order[field],
        fieldSecondary,
        orderSecondary
      });

      this.trackLbxSort(field, this.order[field]);
    },
    changeSortDisplay(field, order) {
      let sort = this.displaySort;

      if (field == 'price') {
        if (order == 'asc')
          sort = this.lang == 'fr_CA' ? '<strong>Prix :</strong> Croissant' : '<strong>Price:</strong> Low to High';
        else
          sort = this.lang == 'fr_CA' ? '<strong>Prix :</strong> Décroissant' : '<strong>Price:</strong> High to Low';
      }
      else if (field == 'year') {
        if (order == 'asc')
          sort = this.lang == 'fr_CA' ? '<strong>Année :</strong> Du plus ancien au plus récent' : '<strong>Year:</strong> Oldest to Newest';
        else
          sort = this.lang == 'fr_CA' ? '<strong>Année :</strong> Du plus récent au plus ancien' : '<strong>Year:</strong> Newest to Oldest';
      }
      else if (field == 'mileage') {
        if (order == 'asc')
          sort = this.lang == 'fr_CA' ? '<strong>Kilométrage :</strong> Croissant' : '<strong>Mileage:</strong> Low to High';
        else
          sort = this.lang == 'fr_CA' ? '<strong>Kilométrage :</strong> Décroissant' : '<strong>Mileage:</strong> High to Low';
      }
      else if (field == 'ininventory') {
        if (order == 'asc')
          sort = this.lang == 'fr_CA' ? 'En inventaire depuis longtemps' : 'Longest in Stock';
        else
          sort = this.lang == 'fr_CA' ? 'Ajouté récemment' : 'Recently Added';
      }

      this.displaySort = sort;
    },
    sortBy(field, order) {
      this.changeSortDisplay(field, order);
      const pathname = window.location.pathname;
      const query = window.location.search || '';

      var a = pathname.replace(/\/?sort_order\/[a-zA-Z]+\//gi, '/');
      var b = a.replace(/\/?sort_by\/[a-zA-Z]+\//gi, '/');

      var url = '/sort_by/' + field + '/sort_order/' + order + '/';
      var finalUrl = b + url + query;
      history.replaceState({}, null, finalUrl.replace('//', '/'));
      this.sort = "";
      this.order = order;
      
      // Get urlParams to include secondary sort parameters
      const urlParams = new URLSearchParams(query);
      let fieldSecondary = urlParams.get('sort_by_secondary') || (this.gutembergOpts?.sort_by_secondary || 'none');
      let orderSecondary = urlParams.get('sort_order_secondary') || (this.gutembergOpts?.sort_order_secondary || 'none');

      if (field === 'year' && fieldSecondary === 'none') {
        fieldSecondary = 'ininventory';
        orderSecondary = order;
      }

      EventBus.$emit('sortInventory', {
        field,
        order,
        fieldSecondary,
        orderSecondary
      });

      this.trackLbxSort(field, order);
    },
    display(component) {
      this.$emit('hideallcomponents', component);
      this.show = !this.show;
      this.$emit('update', {
        component,
        checked: this.checked,
      })
    },
    toggle(component) {
      this.$emit('setpivot', component);

      if (this.checked.length == 0) {
        this.$emit('unsetpivot', component);
      }
      this.$emit('updatechecked', {
        component,
        checked: this.checked,
      })
    },
  },
  watch: {
    checked() {
      if (this.checked.length > 0)
        this.displayName = this.checked.join(',');
      else
        this.displayName = this.title;
    },
    collapse(v) {
      this.show = v
    },
    items(currentVal) {
      if (currentVal.length == 1) {
        this.uniqueInList = currentVal[0];
        this.checked = [];
        this.checked.push(this.uniqueInList);
      } else if (!this.pivot) {
        this.checked = []
      }
    },
  },
  computed: {
    isResponsive() {
      return !this.disableResponsive == true;
    },
    displayName() {
      if (this.sort == '')
        return this.title;

      var desc = this.$t('high to low');
      var asc = this.$t('low to high');
      if (this.sort == 'Year') {
        desc = this.$t('newest to oldest');
        asc = this.$t('oldest to newest');
      }
      var sortTranslation = this.$t(this.sort.toLowerCase())
      var sortByCondition = { desc, asc };
      if (sortTranslation == "rebatesamount") {
        if (this.propTitle == "Sélectionner le type")
          sortTranslation = "Rabais";
        else
          sortTranslation = "Discount";
        if (this.sortCondition == "asc")
          this.sortCondition = "desc"
        else
          this.sortCondition = "asc";
        return `${sortTranslation}: ${sortByCondition[this.sortCondition]}`;
      }

      return `${sortTranslation}: ${sortByCondition[this.sortCondition]}`;
    }
  }
}
